import { AssessmentKeys } from '@uplift/types';
import { restClient } from '../../client';


type AppointmentReminder = {
  type: 'raw';
  message: string;
} | {
  type: 'assessment';
  key: AssessmentKeys;
  name: string;
  score: number;
} | {
  type: 'psychiatry_session';
  key: (
    | 'completed_first_session'
    | 'scheduled_first_session'
    | 'cancelled_first_session'
    | 'did_not_show_up_to_first_session'
  );
};


export const getAppointmentReminders = async (appointmentId: string) => {
  return restClient.request<{ data: AppointmentReminder[] }>(`/api/v1/appointment/${appointmentId}/reminders`);
};
